module.exports = __webpack_public_path__ + "img/check-red-icon.11cbc44b.svg";